import openErrorModal from "../Error/ErrorModal";
import Mediator from "../Utilities/Mediator";
import { updateVariantDisplayOrder } from "../HTTPRequests/VariantRequests";
import Variant from "../Models/Variant";
import SortElementsByDrag from "../Utilities/SortElementsByDrag";
import { fetchVariantsDisplayOrderModal } from "../HTTPRequests/ServiceRequests";
import Loader from "../DomUtilities/Loader";

export default class VariantsDisplayOrderModal {
	modalDiv: HTMLDivElement;
	serviceId: string;

	constructor(serviceId: string, icon: HTMLElement) {
		this.serviceId = serviceId;
		this.modalDiv = document.createElement("div");

		this.init(icon);
	}

	private init(icon: HTMLElement) {
		icon.onclick = (event: MouseEvent) => {
			event.stopPropagation();
			icon.classList.add('clicked');
			setTimeout(() => icon.classList.remove('clicked'), 200);
			Loader.show();
			this.openModal();
		}
	}

	private openModal() {
		fetchVariantsDisplayOrderModal(this.serviceId)
			.then((response: string) => {
				this.modalDiv.innerHTML = response;
				document.body.appendChild(this.modalDiv);
				this.addModalButtonsClickListeners();
				this.addDragListeners();
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private addModalButtonsClickListeners() {
		const closeImage: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		const cancelButton: HTMLButtonElement = this.modalDiv.querySelector('button');
		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('button + button');

		window.onclick = (event: MouseEvent) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		closeImage.onclick = () => {
			this.modalDiv.remove();
		}

		cancelButton.onclick = () => {
			this.modalDiv.remove();
		}

		saveButton.onclick = () => {
			Loader.show();
			this.saveDisplayOrder();
		}
	}

	private saveDisplayOrder() {
		const variants: NodeListOf<HTMLDivElement> = this.modalDiv.querySelectorAll("ul#all-variants > li");
		const variantsList = new Array<Variant>();
		variants.forEach((variant, index) => {
			const variantIndex: number = parseInt(variant.dataset.variantIndex);
			if (variantIndex != index) {
				const variantObject = new Variant();
				variantObject.id = variant.id;
				variantObject.displayOrder = index + 1;
				variantsList.push(variantObject);
			}
		});
		updateVariantDisplayOrder(this.serviceId, variantsList)
			.then(() => {
				Mediator.emit("serviceCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
				this.modalDiv.remove();
			});
	}

	private addDragListeners() {
		const variantsList = document.getElementById('all-variants');
		new SortElementsByDrag(variantsList);
	}
}
